import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { Observable } from 'rxjs';
import { ICCNDisciplineInputModel, ICCNApproverInputModel, ICCNNoInputModel, ICCNInputModel, ICCNManhoursInputModel, ICCNDiscMembersInputModel, ICCNDetailsInputModel, ICCNListInputModel, ICCNApproveInputModel, ICCNUpdateInputModel, ICCNByIdModel, ICCNTagDocInputModel, IScheduleAfterGFCModel, IDocWorkflowPlanModel, IWorkflowAfterGFCModel, IDocWorkflowManHrsModel } from 'src/app/ViewModel/CCNModel';

@Injectable({
  providedIn: 'root'
})
export class CcnService {
  private urlPath = {
    getDiscipline: 'CCN/GetDisciplineDetails',
    getApprover: 'CCN/GetApproverDetails',
    generateCCNNo: 'CCN/GenerateCCNNo',
    insertCCN: 'CCN/InsertCCN',
    getCCNManhours: 'CCN/GetCCNManhours',
    getCCNDiscMembers: 'CCN/GetCCNDiscMembers',
    insertCCNDetails: 'CCN/InsertCCNDetails',
    getCCNDetails: 'CCN/GetCCNDetails',
    getCCNById:'CCN/GetCCNById',
    getCCNList: 'CCN/GetCCNList',
    approveCCN: 'CCN/ApproveCCN',
    submitCCN: 'CCN/SubmitCCN',
    publishCCN: 'CCN/PublishCCN',
    tagCCN: 'CCN/InsertCCNDocument',
    wfAfterGFC: 'WorkflowTransaction/InsertWorkflowAfterGFC',
    scheduleAfterGFC: 'WorkflowTransaction/InsertScheduleAfterGFC',
    insertDocWFPlan:'WorkflowTransaction/InsertDocumentWorkflowPlan',
    insertDocWFManHrs:'WorkflowTransaction/InsertDocumentWorkflowManHours'
  }
  constructor(private restAPIService: RestApiService) { }

  public GetDisciplineDetails(ccnInput: ICCNDisciplineInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.getDiscipline, ccnInput);
  }

  public GetApproverDetails(ccnInput: ICCNApproverInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.getApprover, ccnInput);
  }

  public GenerateCCNNo(ccnInput: ICCNNoInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.generateCCNNo, ccnInput);
  }

  public InsertCCN(ccnInput: ICCNInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.insertCCN, ccnInput);
  }

  public GetCCNManhours(ccnInput: ICCNManhoursInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.getCCNManhours, ccnInput);
  }

  public GetCCNDiscMembers(ccnInput: ICCNDiscMembersInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.getCCNDiscMembers, ccnInput);
  }

  public InsertCCNDetails(ccnInput: ICCNDetailsInputModel[]): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.insertCCNDetails, ccnInput);
  }

  public GetCCNDetails(ccnInput: ICCNManhoursInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.getCCNDetails, ccnInput);
  }

  public GetCCNById(ccnInput: ICCNByIdModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.getCCNById, ccnInput);
  }

  public GetCCNList(ccnInput: ICCNListInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.getCCNList, ccnInput);
  }

  public ApproveCCN(ccnInput: ICCNApproveInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.approveCCN, ccnInput);
  }

  public SubmitCCN(ccnInput: ICCNUpdateInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.submitCCN, ccnInput);
  }

  public PublishCCN(ccnInput: ICCNUpdateInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.publishCCN, ccnInput);
  }

  public TagCCN(ccnInput: ICCNTagDocInputModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.tagCCN, ccnInput);
  }

  public InsertWorkflowAfterGFC(inputModel: IWorkflowAfterGFCModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.wfAfterGFC, inputModel);
  }

  public InsertScheduleAfterGFC(inputModel: IScheduleAfterGFCModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.scheduleAfterGFC, inputModel);
  }

  public InsertDocumentWorkflowPlan(inputModel: IDocWorkflowPlanModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.insertDocWFPlan, inputModel);
  }

  public InsertDocumentWorkflowManHours(inputModel: IDocWorkflowManHrsModel): Observable<any> {
    return this.restAPIService.new_POST(this.urlPath.insertDocWFManHrs, inputModel);
  }
}
